import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getOperacoesColumns } from './tanStackColumns';

const OperacoesTable = ({
  data,
  onRowClick,
  loading
}) => {
  return <Row>
      <Col md={12}>
        <TanStackTable columns={getOperacoesColumns()} data={data} onRowClick={onRowClick || undefined} isSortable={true} withPagination={true} pageSizeOptions={[10, 25, 50, 100]} enableRowColors={true} loading={!!loading} className="mt-3" />
      </Col>
    </Row>;
};

export default OperacoesTable;
